import { Component } from '@angular/core';
import { SubAreaService } from '../sub-area/sub-area.service';
import { mainMapMngr } from '../asp/MapMngr';
import * as settings from '../common/settings';
import { AppConfig } from '../app.config';

//
// Map Bar
//
@Component({
  templateUrl: './map-bar.component.html',
  styleUrls: ['./menu-bars.scss']
})
export class MapBarComponent {
  private visible: boolean = false;
  private mapOutline: boolean = true;
  private mapSat: boolean = false;
  private mapOffline: boolean = false;

  private in3DMapSelection = false;

  constructor(private subArea: SubAreaService) {
  }

  toggleVisible() {
    this.visible = !this.visible;
  }

  onOutlineMapClick() {
    // mainMapMngr.switchMap(0);
    settings.userSettings.SetMapIndex(0);
    if (!this.mapOutline) {
      this.mapOutline = true;
      this.mapSat = false;
      this.mapOffline=false;
      this.visible = false;
    }
  }

  onSatMapClick() {
    settings.userSettings.SetMapIndex(1);
    if (!this.mapSat) {
      this.mapOutline = false;
      this.mapSat = true;
      this.mapOffline=false;
      this.visible = false;
    }
  }

  onOfflineMapClick(){
    settings.userSettings.SetMapIndex(2);
    if (!this.mapOffline) {
      this.mapOutline = false;
      this.mapSat = false;
      this.visible = false;
    }

  }



  isVisible() {
    return this.visible;
  }

  isOutlineMap() {
    return this.mapOutline;
  }

  isSatMap() {
    return this.mapSat;
  }

  isOfflineMap(){
    return this.mapOffline;
  }
  on3DMapClick() {
    mainMapMngr.activateCreateTool(NeWMI.Geometry.Enums.EGeometryType.Rectangle, this.onCreateToolFinish.bind(this));
    this.in3DMapSelection = true;
  }

  private onCreateToolFinish(this: MapBarComponent, geometry: any) {
    this.in3DMapSelection = false;
    this.visible = false;

    let extent = new settings.MapExtent(geometry.xCenter, geometry.yCenter, geometry.width, geometry.height);
    this.subArea.createSubArea(true /* Is 3D */, extent);
  }

  is3DMapDisabled() {
    return !AppConfig.settings.map.esri || !mainMapMngr.defaultToolActive() || !this.subArea.canCreateSubArea(true /* Is 3D */) || this.in3DMapSelection;
  }
}
